import { render, staticRenderFns } from "./pageAtoZList.vue?vue&type=template&id=4ea2431a&"
import script from "./pageAtoZList.vue?vue&type=script&lang=js&"
export * from "./pageAtoZList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports